import { css } from 'styled-components';

import { COLORS, BREAKPOINTS, LAYOUT } from './index';

// Re-export de variables castées en number
export const NAV_HEIGHT = parseInt(LAYOUT.NAV_HEIGHT, 10);
export const TREEVIEW_WIDTH = parseInt(LAYOUT.TREEVIEW_WIDTH, 10);
export const TREEVIEW_MARGIN = parseInt(LAYOUT.TREEVIEW_MARGIN, 10);

/** @deprecated Utiliser `@include notification-dot` */
export const notificationStyle = css`
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background: ${COLORS.FLAG_PUMPKIN};
`;

/** @deprecated Utiliser `@include mq(min, max)` */
export const getMediaQuery = (min: number | null, max: number | null) => {
  const minQuery = `(min-width: ${min ?? 0}px)`;
  const maxQuery = max != null && `(max-width: ${max - 0.1}px)`;
  return ['screen', minQuery, maxQuery].filter(Boolean).join(' and ');
};

/** @deprecated Utiliser `@include mqUp('<NAME>')` */
export const media = Object.fromEntries(
  Object.entries(BREAKPOINTS).map(([breakpointName, breakpointValue]) => {
    const fn: typeof css = (...args: Parameters<typeof css>) => css`
      @media ${getMediaQuery(breakpointValue, null)} {
        ${css(...args)};
      }
    `;
    return [breakpointName, fn];
  }),
) as Record<keyof typeof BREAKPOINTS, typeof css>;
